/* eslint-disable max-len */
import React, { useState } from 'react';
import Buttons from '../../components/Buttons';
import DashboardWrap from '../../components/DashboardWrap';
import PlusIcon from '../../svgs/PlusIcon';

import Styles from './PartnerTrackingCode.module.scss';
import PartnerTrackingRecordSection from './PartnerTrackingRecord';
import PartnerTrackingDashboard from './PartnerTrackingDashboard';

const PartnerTrackingCode = () => {
  const [isShowGenerateCodeModal, setIsShowGenerateCodeModal] = useState(false);

  return (
    <DashboardWrap>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__header}>
          <div className={Styles.wrapper__title}>Partner Tracking Code</div>
          <div className={Styles.wrapper__buttonContainer}>
            <Buttons
              name="Generate new tracking code"
              Icon={PlusIcon}
              onClick={() => setIsShowGenerateCodeModal(true)}
            />
          </div>
        </div>
        <PartnerTrackingDashboard />
        <PartnerTrackingRecordSection
          isShowGenerateCodeModal={isShowGenerateCodeModal}
          setIsShowGenerateCodeModal={(data: boolean) => setIsShowGenerateCodeModal(data)}
        />
      </div>
    </DashboardWrap>
  );
};

export default PartnerTrackingCode;
